













import { defineComponent, PropType, toRefs } from '@nuxtjs/composition-api'

import useCommentLink from '@/composables/use-comment-link'

import Store from '@/classes/Store'

export default defineComponent({
  props: {
    store: {
      type: Object as PropType<Store | null>,
      default: null,
    },
    size: {
      type: String as PropType<'xs' | 'lg'>,
      default: 'xs',
    },
    hideCount: {
      type: Boolean,
      default: false,
    },
  },
  setup (props) {
    return {
      commentLink: useCommentLink(toRefs(props).store),
    }
  },
})
